import { IconProps } from ".";

export const IoNetIconLight: React.FC<IconProps> = (props) => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 1436 206" fill="none" {...props}>
      <path d="M473.976 153.76H421.312V205.014H473.976V153.76Z" fill="currentColor" />
      <path
        d="M773.462 4.95448H773.286C769.951 1.70844 765.562 0 760.822 0H555.959C551.219 0 546.831 1.87928 543.495 4.95448L518.743 29.0436C515.408 32.2896 513.653 36.5608 513.653 41.1736V205.014H566.317V51.2534H750.641V205.014H803.305V41.1736C803.305 36.5608 801.374 32.2896 798.214 29.0436L773.462 4.95448Z"
        fill="currentColor"
      />
      <path
        d="M859.655 4.95448H859.48L834.728 29.0436C831.392 32.2896 829.637 36.5608 829.637 41.1736V51.2534H1119.29V0H872.119C867.379 0 862.991 1.87928 859.655 4.95448Z"
        fill="currentColor"
      />
      <path
        d="M871.943 77.0509C867.204 77.0509 862.815 78.9302 859.48 82.0054L834.728 106.095C831.392 109.341 829.637 113.612 829.637 118.224V163.84C829.637 168.453 831.568 172.724 834.728 175.97L859.48 200.059C862.815 203.305 867.204 205.014 871.943 205.014H1119.29V153.76H882.125V128.133H1119.29V76.8801H871.943V77.0509Z"
        fill="currentColor"
      />
      <path
        d="M352.673 4.95448C349.338 1.70844 344.949 0 340.21 0H121.304C116.565 0 112.176 1.87928 108.841 4.95448L84.0885 29.0436C80.7531 32.2896 78.9976 36.5608 78.9976 41.1736V51.2534H330.028V128.133H382.692V41.1736C382.692 36.5608 380.761 32.2896 377.601 29.0436L352.849 4.95448H352.673Z"
        fill="currentColor"
      />
      <path
        d="M131.66 153.76V76.8801H78.996V163.84C78.996 168.453 80.9271 172.724 84.0869 175.97L108.839 200.059C112.174 203.305 116.563 205.014 121.303 205.014H340.385C345.125 205.014 349.514 203.134 352.849 200.059L377.601 175.97C380.936 172.724 382.692 168.453 382.692 163.84V153.76H131.66Z"
        fill="currentColor"
      />
      <path
        d="M0 163.84C0 168.453 1.93102 172.724 5.09086 175.97L29.8429 200.059C33.1783 203.305 37.567 205.014 42.3068 205.014H52.664V76.8801H0V163.84Z"
        fill="currentColor"
      />
      <path
        d="M29.8429 4.95448L5.09086 29.0436C1.75547 32.2896 0 36.5608 0 41.1736V51.2534H52.664V0H42.3068C37.567 0 33.1783 1.87928 29.8429 4.95448Z"
        fill="currentColor"
      />
      <path
        d="M1430 29.0436L1405.25 4.95448H1405.08C1401.74 1.87928 1397.35 0 1392.61 0H1316.6V51.2534H1435.09V41.1736C1435.09 36.5608 1433.34 32.2896 1430 29.0436Z"
        fill="currentColor"
      />
      <path
        d="M1286.76 4.95448C1283.43 1.70844 1279.04 0 1274.3 0H1188.1C1183.36 0 1178.97 1.87928 1175.64 4.95448H1175.46L1150.71 29.0436C1147.38 32.2896 1145.62 36.5608 1145.62 41.1736V51.2534H1263.94V205.014H1316.6V40.8319C1316.6 36.3899 1314.67 32.2896 1311.51 29.0436L1286.76 4.95448Z"
        fill="currentColor"
      />
    </svg>
  );
};
